module.exports = __webpack_public_path__ + "img/icon_report.6ae38052.svg";